import script from "./TextClamp.vue?vue&type=script&setup=true&lang=js"
export * from "./TextClamp.vue?vue&type=script&setup=true&lang=js"

import "./TextClamp.vue?vue&type=style&index=0&id=5589779f&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5589779f"]])

export default __exports__